import { AriaRoles } from '../constants/AccessibilityConstants';

export const AriaRolesArray = Object.keys(AriaRoles).map(key => {
  return AriaRoles[key];
});
